import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles.css'
import { App } from './App'

const container = document.getElementById('root')
if (!container) throw new Error('عنصر #root غير موجود في index.html')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
